<template>
  <div>
    <b-navbar toggleable="md">
      <b-navbar-toggle target="nav-collapse">
        <font-awesome-icon icon="bars" size="1x" />
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item
            v-if="buildingOwnerId != null || contactId != null"
            :to="{ name: 'profile' }"
            :class="{ 'is-active': subIsActive('/profile') }"
            class="text-md-center"
          >
            <font-awesome-icon icon="user-circle" size="1x" />
            <span class="d-inline ">Mon compte</span>
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item
            v-if="buildingOwnerId != null || contactId != null"
            :to="{ name: 'meetings' }"
            :class="{ 'is-active': subIsActive('/meetings') }"
            class="text-md-center"
          >
            <font-awesome-icon icon="users" size="1x" />
            <span class="d-inline">Convocations</span>
          </b-nav-item>

          <b-nav-item
            v-if="meetingGuestId != null"
            :to="{ name: 'meetings' }"
            :class="{ 'is-active': subIsActive('/meetings') }"
            class="text-md-center"
            @click="logout"
          >
            <font-awesome-icon icon="sign-out-alt" size="1x" />
            <span class="d-inline">Se déconnecter</span>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      buildingOwnerId: null,
      contactId: null,
      meetingGuestId: null,
    };
  },
  computed: {
    buildingOwners() {
      return BuildingOwnerORM.all();
    },
    isLoginLoading() {
      return this.$store.state.isLoginLoading;
    },
  },
  watch: {
    isLoginLoading(newValue) {
      if (newValue == false) {
        this.buildingOwnerId = localStorage.building_owner_id;
        this.contactId = localStorage.contact_id;
        this.meetingGuestId = localStorage.meeting_guest_id;
      }
    },
  },
  mounted() {
    this.buildingOwnerId = localStorage.building_owner_id;
    this.contactId = localStorage.contact_id;
    this.meetingGuestId = localStorage.meeting_guest_id;
  },
  methods: {
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        this.$parent.selectedBuilding = null;
        this.$router.push({ name: "login" });
      });
    },
  },
};
</script>
